module.exports = __webpack_public_path__ + "img/opp-errf-point.86b27345.png";